/* assets/sf-compare.js - TBL-01 Vergleich (24.09.2026), gehört zu snippets/sf-compare.liquid.
   Schmale Ansicht (Container unter 720 px, siehe sf-compare.css): "vs."-Chips, Punkte und
   Wischen wählen den Wettbewerber neben der eigenen Spalte. Die breite Ansicht zeigt alle
   Spalten und nutzt nur den Button zur Kaufbox. Ohne Skript scrollt die Tabelle seitlich.
   25.09.2026: Chips stehen in einer wischbaren Zeile; der aktive Chip rollt in Sicht (nur
   die Zeile, nie die Seite). Der Kaufbutton springt zur Kaufbox, auch wenn sein #-Ziel auf
   der Seite fehlt (z. B. "#buybox" auf der Sportler-Seite); ohne Kaufbox gilt
   data-sfcmp-fallback. */
(function () {
  if (!window.customElements || customElements.get('sf-compare')) return;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  class SfCompare extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.index = 0;
      this.heads = Array.prototype.slice.call(this.querySelectorAll('thead [data-c]'));
      this.count = this.heads.length;
      this.cells = Array.prototype.slice.call(this.querySelectorAll('[data-c]'));
      this.ctrls = Array.prototype.slice.call(this.querySelectorAll('[data-sfcmp-go]'));
      this.live = this.querySelector('[data-sfcmp-live]');

      var cta = this.querySelector('[data-sfcmp-cta]');
      if (cta) cta.addEventListener('click', this.toBuybox.bind(this));
      this.bar = this.querySelector('.sfcmp__switch');

      if (this.count < 2) return;
      this.querySelectorAll('[data-sfcmp-ui]').forEach(function (el) { el.hidden = false; });
      this.classList.add('is-js');

      var self = this;
      this.ctrls.forEach(function (btn) {
        btn.addEventListener('click', function () { self.go(parseInt(btn.getAttribute('data-sfcmp-go'), 10)); });
      });
      this.bindSwipe(this.querySelector('[data-sfcmp-swipe]'));
    }

    go(i) {
      if (isNaN(i) || i < 0 || i >= this.count || i === this.index) return;
      var dir = i > this.index ? 'r' : 'l';
      this.index = i;
      this.cells.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-c') === String(i)); });
      this.ctrls.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sfcmp-go') === String(i) ? 'true' : 'false'); });
      this.showChip(i);
      this.classList.remove('is-enter-r', 'is-enter-l');
      if (!reduce.matches) {
        void this.offsetWidth;
        this.classList.add('is-enter-' + dir);
      }
      if (this.live) {
        var name = this.heads[i].querySelector('.sfcmp__name');
        this.live.textContent = 'Vergleich mit ' + (name ? name.textContent.trim() : '');
      }
    }

    bindSwipe(area) {
      if (!area || !window.PointerEvent) return;
      var self = this, x0 = 0, y0 = 0, id = null;
      area.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        id = e.pointerId; x0 = e.clientX; y0 = e.clientY;
      });
      area.addEventListener('pointerup', function (e) {
        if (e.pointerId !== id) return;
        id = null;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        if (!self.isNarrow()) return;
        self.go(self.index + (dx < 0 ? 1 : -1));
      });
      area.addEventListener('pointercancel', function () { id = null; });
    }

    showChip(i) {
      var bar = this.bar, chip = bar && bar.querySelector('[data-sfcmp-go="' + i + '"]');
      if (!chip || bar.scrollWidth <= bar.clientWidth) return;
      var left = chip.offsetLeft - (bar.clientWidth - chip.offsetWidth) / 2;
      bar.scrollTo({ left: Math.max(0, left), behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    isNarrow() {
      var sw = this.querySelector('.sfcmp__switch');
      return !!sw && window.getComputedStyle(sw).display !== 'none';
    }

    toBuybox(e) {
      var a = e.currentTarget, href = a.getAttribute('href') || '';
      var toBox = a.hasAttribute('data-sfcmp-buybox');
      if (!toBox && href.charAt(0) !== '#') return;               /* normaler Link */
      var target = null;
      if (!toBox && href.length > 1) {
        try { target = document.getElementById(decodeURIComponent(href.slice(1))); } catch (err) { target = null; }
      }
      if (!target) {
        target = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product__info') || document.querySelector('[data-sf-main-product]');
      }
      if (!target) {
        var fb = a.getAttribute('data-sfcmp-fallback');
        if (fb) { e.preventDefault(); window.location.href = fb; }
        return;
      }
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce.matches ? 'auto' : 'smooth' });
      var title = target.querySelector('h1, h2');
      if (title) {
        if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '-1');
        title.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('sf-compare', SfCompare);
})();
